<template>
  <div class="overview">
    <!-- eslint-disable-next-line vue/valid-v-for -->
    <div
      v-for="item in overviewList"
      :key="item.id"
    >
      <div class="box">
        <img
          :src="item.src"
          alt
        />
        <div style="margin-left: 8px;">
          <div class="title">{{ item.title }}</div>
          <div class="amount">
            {{ item.amount }}
            <span>个</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      overviewList: [
        {
          id: 1,
          src: '/icon-backlog@2x.png',
          title: '待办任务',
          amount: '221'
        },
        {
          id: 2,
          src: '/icon-repair-order@2x.png',
          title: '待办工单',
          amount: '82'
        },
        {
          id: 3,
          src: '/icon-ongoing@2x.png',
          title: '正在进行',
          amount: '50'
        },
        {
          id: 4,
          src: '/icon-deputation@2x.png',
          title: '待审',
          amount: '18'
        },
        {
          id: 5,
          src: '/icon-complete@2x.png',
          title: '本年完成',
          amount: '2610'
        }
      ]
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    getList () {
      // 工单统计
      this.$http.get('/pipe-network/inspection/workbench/status-num').then(res => {
        
        this.overviewList[0].amount = res.data.taskNum
        this.overviewList[1].amount = res.data.workNum
        this.overviewList[2].amount = res.data.conductNum
        this.overviewList[3].amount = res.data.pendingTrialNum
        this.overviewList[4].amount = res.data.completeNum
      })
    }
  }
}
</script>

<style lang='less' scoped>
.overview {
  width: 100%;
  height: 103px;
  margin-bottom: 2.4%;
  background-image: url(/iconImg/xjwx-bj.png);
  background-size: 100% 100%;
  border-radius: 4px;
  display: flex;
  justify-content: space-around;
}
.box {
  display: flex;
  margin-top: 20px;
}
img {
  width: 22px;
  height: 22px;
}
.title {
  font-family: MicrosoftYaHei;
  font-size: 16px;
  color: #404549;
  letter-spacing: 0.09px;
  font-weight: 400;
}
.amount {
  font-family: MicrosoftYaHeiSemibold;
  font-size: 24px;
  color: #000000;
  letter-spacing: 0.13px;
  font-weight: 600;
}
span {
  font-family: MicrosoftYaHeiSemibold;
  font-size: 16px;
  color: #404549;
  letter-spacing: 0.09px;
  text-align: right;
  font-weight: 600;
}
</style>
